var React = require('react');

function SDCPlay18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.4209,16.75a1.16853,1.16853,0,0,1-.83789-.35742,1.18878,1.18878,0,0,1-.333-.83008V2.4375a1.18878,1.18878,0,0,1,.333-.83008A1.16849,1.16849,0,0,1,3.4209,1.25H4.68555a1.62613,1.62613,0,0,1,.84179.23633L16.15039,7.92871a1.25924,1.25924,0,0,1-.002,2.14649L5.5166,16.51465a1.62219,1.62219,0,0,1-.833.23535Zm.3291-1.5h.92871L15.02539,9.001,4.68555,2.75H3.75Z","fill":"var(--iconFill, #464646)"}));
}

SDCPlay18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCPlay18N;

SDCPlay18N.default = SDCPlay18N;
